import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {getPartyById} from '../core/_requests'
import {useListView} from '../core/ListViewProvider'
import {PartyEditModalForm} from './PartyAddEditForm'

const PartyEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: party,
    error,
  } = useQuery(
    `${QUERIES.SERVICECENTERS_LIST}-party-${itemIdForUpdate}`,
    () => {
      return getPartyById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <PartyEditModalForm isPartyLoading={isLoading} party={{id: undefined}} />
  }

  if (!isLoading && !error && party) {
    return <PartyEditModalForm isPartyLoading={isLoading} party={party} />
  }

  return null
}

export {PartyEditModalFormWrapper}
